var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClinkLogoStatic = function SvgIconClinkLogoStatic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    "data-name": "Component 16 \\u2013 1",
    viewBox: "0 0 40.001 39.999"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed1164",
    d: "M20.001 0a20 20 0 1 0 0 40 5.492 5.492 0 1 1 0-10.983 9.017 9.017 0 1 1 0-18.034 5.491 5.491 0 1 0 0-10.982Z",
    "data-name": "Path 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4cc0ad",
    d: "M20.001 0a5.491 5.491 0 1 1 0 10.982 9.017 9.017 0 1 1 0 18.034 5.492 5.492 0 1 0 0 10.983 20 20 0 1 0 0-40Z",
    "data-name": "Path 2"
  }))));
};
export default SvgIconClinkLogoStatic;